// import React, { useState } from "react";
// import { Input, Select, Button } from "antd";
// import { Monitor, ArrowRight } from "lucide-react";
// import LedMatrix from "./LedMatrix";   // ⬅️ IMPORTANT
// import BussImage from "../../assets/Image/buss-preview.png";   // ⬅️ IMPORTANT
// import "./LedScreen.css";

// const PreviewLed = ({ data }) => {
//     // TEXT STATES

//     console.log('perivew data',data)
//     const [numeratore, setNumeratore] = useState(data?.numeratore);
//     const [rigaSuperiore, setRigaSuperiore] = useState(data?.riga_superiore);
//     const [rigaInferiore, setRigaInferiore] = useState(data?.riga_inferiore);

//     // COLOR STATES
//     const [numeratoreColor, setNumeratoreColor] = useState(data?.numeratore_color);
//     const [rigaSuperioreColor, setRigaSuperioreColor] = useState(data?.riga_superiore_color);
//     const [rigaInferioreColor, setRigaInferioreColor] = useState(data?.riga_inferiore_color);

//     return (

//         <div className="led-right-section">
//             <h2 className="preview-title">Preview</h2>
//             <p className="preview-sub">Anteprima indicatoria</p>

//             <div className="bus-preview-container">
//                 <img
//                     src={BussImage}
//                     alt="Bus LED Preview"
//                     className="bus-image"
//                 />

//                 <div className="bus-led-overlay">
//                     <LedMatrix
//                         line1={numeratore}
//                         color1={numeratoreColor}
//                         line2={rigaSuperiore}
//                         color2={rigaSuperioreColor}
//                         line3={rigaInferiore}
//                         color3={rigaInferioreColor}
//                         bgColor="#000000"
//                     />

//                 </div>
//             </div>
//         </div>
//     );
// };

// export default PreviewLed;
import React from "react";
import LedMatrix from "./LedMatrix";
import BusFront from "../../assets/Image/buss-preview.png";
import BusSide from "../../assets/Image/sidelogo.png";
import BusRear from "../../assets/Image/bus-rear-view-png.jpeg";
import "./LedScreen.css";
import { translations } from "../../utils/constants";

const PreviewLed = ({ data, language }) => {
    const text = data?.text || "";
    const role = data?.panel_role;
    const textColor = data?.text_color || "#ffffff";
    const bgColor = data?.back_color || "#000000";

    // image selection
    const getBusImage = () => {
        if (role === "side") return BusSide;
        if (role === "rear") return BusRear;
        return BusFront;
    };

    // 🔥 IMPORTANT: front & side SAME LED HEIGHT
    const getLedClass = () => {
        if (role === "rear") return "led-rear";
        if (role === "side") return "led-side-top";
        return "led-front";
    };

    return (
        <div className="led-right-section">
            <h2 className="preview-title">{translations[language]?.preview}</h2>

            <div className="bus-preview-container">
                <img
                    src={getBusImage()}
                    className="bus-image"
                    alt="Bus"
                />

                <div className={`bus-led-overlay ${getLedClass()}`}>
                    <LedMatrix
                        line1={text}
                        color1={textColor}
                        bgColor={bgColor}
                    />

                </div>
            </div>
        </div>
    );
};

export default PreviewLed;
